import { axiosInstance } from "@/lib/axios";
import type { CategoriesResponse, CategoryType } from "./types";

/** List categories for a section: nft, collection or blog. */
export async function getCategories(type: CategoryType): Promise<CategoriesResponse> {
  const { data } = await axiosInstance.get<CategoriesResponse>(`/category/${type}`);
  return data;
}
